import React from "react"

const ContactSection = () => {
  return (
    <section className="bg-gradient-to-r from-[#f0f8ff] to-[#fff8e1] py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center max-w-5xl mx-auto">
          <div className="text-center md:text-left relative">
            <h2 className="text-2xl font-bold mb-2 text-[#0072bc]">Resolving your complaints!</h2>
            <p className="text-gray-600 mb-4">Submit your issue and we'll get back to you.</p>

            <div className="hidden md:block relative h-64 w-full">
              <img
                src="https://img.freepik.com/free-vector/flat-customer-support-illustration_23-2148899114.jpg?w=740&t=st=1679669964~exp=1679670564~hmac=15a1b5a4a7ebcb6a6da0b5d4b24c35d5c5b62129fae0054cc32b6363384dcd2b"
                alt="Customer support illustration"
                className="h-full ml-4 object-contain"
              />
              <div className="absolute top-1/4 right-0 transform translate-x-1/2">
                <svg width="100" height="60" viewBox="0 0 100 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 30H70L100 0V60L70 30H0Z" fill="#0072bc" />
                </svg>
              </div>
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-lg">
            <form className="space-y-4">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                  Your Name
                </label>
                <input
                  id="name"
                  type="text"
                  placeholder="John Doe"
                  className="w-full rounded-md border border-gray-300 px-4 py-2 focus:border-[#0072bc] focus:ring-1 focus:ring-[#0072bc] focus:outline-none transition-colors"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                  Email Address
                </label>
                <input
                  id="email"
                  type="email"
                  placeholder="john@example.com"
                  className="w-full rounded-md border border-gray-300 px-4 py-2 focus:border-[#0072bc] focus:ring-1 focus:ring-[#0072bc] focus:outline-none transition-colors"
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                  Your Message
                </label>
                <textarea
                  id="message"
                  placeholder="Please describe your issue..."
                  rows={4}
                  className="w-full rounded-md border border-gray-300 px-4 py-2 focus:border-[#0072bc] focus:ring-1 focus:ring-[#0072bc] focus:outline-none transition-colors"
                />
              </div>
              <button
                type="submit"
                className="w-full rounded-md bg-[#0072bc] px-4 py-3 text-white hover:bg-[#0086da] transition-colors font-medium"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactSection